export default __webpack_public_path__ + "static/media/qiye.822de250.png";